import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import { useContext } from "react"
import { GlobalContext } from '../_app'

import Head from 'next/head'
import Image from "next/image"

import handleContentBlocks from "../../lib/content-blocks"
import handleSeomaticMeta from "../../lib/seomatic"
import { 
    QueryPageHeader,
	QueryText, 
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
    QueryProfileCarousel,
    QuerySEO,
    QueryImages,
	QueryOffsetCallout,
	QueryCards,
	QuerySpacer,
	QueryPartners
} from "../../graphql/queries"

import { Header, HeaderShim } from '../../fuselage/global/header/header'
import { Footer } from '../../fuselage/theme/2024/layout/footer/footer'

import { LogoGrid } from "../../fuselage/layout/logo-grid/logo-grid"
import partnerCSS from '../../css/app/partners.module.css'
import { LEGACY_PARTNERS_2023 } from "../../data/legacy/2023/partners"


function Partners({ seomatic, contentBlocks }) {

	const globals = useContext(GlobalContext)

	// seo

	let metaTitle = JSON.parse(seomatic.metaTitleContainer)
    let metaTags = JSON.parse(seomatic.metaTagContainer) 

	// console.log('contentBlocks:', contentBlocks)


	return (
		<>

			<Head>
                <title>{metaTitle.title.title}</title>

                <meta name="description" content={metaTags.description.content} />
                <meta name="referrer" content={metaTags.referrer.content} />
                {/* <meta name="robots" content={metaTags.robots.content} /> */}
                <meta content={metaTags['og:locale'].content} property="og:locale" />
                <meta content={metaTags['og:site_name'].content} property="og:site_name" />
                <meta content={metaTags['og:type'].content} property="og:type" />
                <meta content={metaTags['og:url'].content} property="og:url" />
                <meta content={metaTags['og:title'].content} property="og:title" />
                <meta content={metaTags['og:description'].content} property="og:description" />
                <meta content={metaTags['og:image'].content} property="og:image"></meta>  
            </Head>

			<Header mainMenu={globals.nodes} />
			<HeaderShim />

			{ handleContentBlocks( contentBlocks, null, null ) }



			<Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>

		</>
	)
}
Partners.theme = 'aviadev-2024'



export async function getStaticProps() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", id: "54163") {
					... on ${process.env.SITE_HANDLE}Partners_${process.env.SITE_HANDLE}Partners_Entry {
						id
						title
						slug
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryPageHeader}
							${QueryText}
							${QueryFlipFlops}
							${QueryFloaters}
							${QueryBillboards}
							${QueryBillboardSliders}
							${QueryImpactFigures}
							${QueryVideos}
							${QueryProfileCarousel}
							${QueryForm}
							${QueryImages}
							${QueryOffsetCallout}
							${QueryCards}
							${QuerySpacer}
							${QueryPartners}
						}
						${QuerySEO}
					}
				}
			}
        `
    })
	
	return {
		props: { 
			seomatic: cmsData.data.entry.seomatic,
			contentBlocks: cmsData.data.entry.aviadevContentBlocks,

		}
	}
}

export default Partners


